<template>
  <div class="all">
    <div class="all_ol" v-if="valueFlag">
      <ol>
        <li
          v-for="(item, index) in allList"
          :key="index"
          @click="valueClick(item, index)"
        >
          {{ item.value }}？
        </li>
      </ol>
    </div>
    <div class="allValue" v-else>
      <div class="breadcrump">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            @click.native="backClick"
            style="font-size: 18px"
            >{{ $route.meta.title }}</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ breadcrumbValue }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="body">
        <h3>{{ breadcrumbValue }}？</h3>
        <ol>
          <li v-for="(item, index) in bodyList" :key="index">
            {{ item.value ? '' : item }}
            <div v-show="item.value" v-html="item.value"/>
            <span>
              <img
                class="fqa_img"
                v-show="item.imgUrl"
                :src="item.imgUrl"
                alt=""
              />
            </span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "All",
 
  data() {
    return {
      valueFlag: true,
      allList: [
        {
          value: "神旗视讯客户端目前支持哪些平台系统",
          body: [
            "神旗视讯当前支持Windows、macOS、iOS、Android及鸿蒙系统(HarmonyOS)：",
            "1. Windows支持Windows 10及以上系统。",
            "2. macOS支持10.15及以上系统 。",
            "3. iOS支持13及以上系统。",
            "4. Android支持10及以上系统。",
            "5. HarmonyOS支持2.0及以上系统",
          ],
        },
        {
          value: "无法安装神旗视讯客户端",
          body: [
            "1. 在神旗视讯官网，选择与您的设备类型匹配的客户端进行下载，iPhone和iPad可前往APP Store搜索“神旗”、“神旗HD”下载安装。",
            "2. 安装时，请确保已安装的神旗视讯客户端是关闭状态。",
            "3. 若客户端已关闭，仍无法安装，请至任务管理器中手动结束神旗视讯进程。",
            "4. 若仍无法安装，重启设备，重新安装。",
          ],
        },
        {
          value: "安装完神旗视讯客户端无法入会",
          body: [
            "1. 检查本地网络是否正常。",
            "2. 打开神旗视讯的“设置”，检查服务器地址和端口是否填写正确。",
            "3. 检查会议号和密码是否输入正确。",
            "4. 若该会议不允许访客入会，请登录后再入会。",
            "5. 会议过期：已被结束的预约会议或已超过预约结束时间的24小时的会，为无效会议，请重新预约会议或开启即时会议。",
          ],
        },
        {
          value: "入会后，听不到对方声音，或者对方听不到我的声音",
          body: [
            "一 若会议中所有人都听不到我的声音：",
            "1. 检查我的神旗视讯客户端“设置”中，若麦克风选择“与系统一致”，则检查我的设备系统是否选用了正确的麦克风，选用的麦克风是否工作正常。",
            "2. 若神旗视讯麦克风选择了特定麦克风设备，检查所选麦克风是否工作正常。",
            "3. 若电脑的声音设备已被其他应用占用，请释放该声音设备或者为神旗视讯选用其他声音设备。",
            "4. 若我的设备同时使用多个声音设备，拔掉其他声音设备，仅保留想使用的声音设备。",
            "5. 在会议工具条中，执行静音后再解除静音。",
            "6. 尝试拔掉再插回所用耳麦或其他麦克风/扬声器设备。",
            "7. 退出会议，重新入会。",
            "二 若会议中其他人能听到对方的声音，而我听不到对方的声音：",
            "1. 检查我的神旗视讯客户端“设置”中，若扬声器选择“与系统一致”，检查我的设备系统是否选用了正确的扬声器，选用的扬声器否工作正常。",
            "2. 若神旗视讯麦克风选择了特定扬声器设备，检查所选扬声器是否工作正常。",
            "3. 若我的声音设备已被其他应用占用，请释放该声音设备或者为神旗视讯选用其他声音设备。",
            "4. 若我的设备同时使用多个声音设备，拔掉其他声音设备，仅保留想使用的声音设备。",
            "5. 关闭再打开本地扬声器。",
            "6. 拔掉再插回所用耳麦或其他麦克风/扬声器设备。",
            "7. 退出会议，重新入会。",
          ],
        },
        {
          value: "入会后，看不到对方的视频，或者对方看不到我的视频",
          body: [
            "1. 检查入会时，是否选择了”仅音频“入会，若当前是”仅音频“入会，那么会议中只有音频，没有视频和共享屏幕。",
            "2. 检查本地网络，若网络状况较差，如带宽过低或网络丢包抖动过大时，则无法发送或接收视频。",
          ],
        },
        {
          value: "会议中出现回声/啸叫/噪音",
          body: [
            "1. 若同一会场（近距离）有多设备入会，仅保持一台设备开启麦克风或者扬声器，其他设备关闭麦克风并使用耳机。",
            "2. 若会场中有大功率音频输出设备，降低音频输出设备的音量，并与会议设备扬声器保持3米以上的距离。",
            "3. 若仍存在回声/啸叫/噪音，会议管理员可以执行全体静音，逐一打开各个参会者的麦克风，找到出现回声/啸叫/噪音的会场，参照1，2中的方法处理。",
            "4. 若出现回声/啸叫/噪音的设备无需发言，则始终关闭该设备的麦克风。",
            "5. 若回声/啸叫/噪音的设备需要发言，可以通过如下两种方式处理：",
            "（1）降低该设备扬声器的音量（建议50%）再发言。",
            "（2）该设备尽量不要使用外放，建议使用耳麦发言。",
            "（3）该设备退会，重新入会；",
            "（4）该设备重启，重新入会。",
          ],
        },
        {
          value: "使用外设麦克风发言时，会议有噪音",
          body: [
            "会议中，如果您使用的是外置麦克风设备，请注意外置麦克风和扬声器保持一定距离，以免产生杂音，影响会议体验。",
          ],
        },
        {
          value:
            "会议中不能看到对方的共享屏幕的内容或对方看不到我的共享屏幕的内容",
          body: [
            "1. 若您入会时，选择了”仅音频“入会，则只有音频，没有视频和共享屏幕。",
            "2. 检查本地网络，若网络状况较差，如带宽过低或网络丢包抖动过大时，则无法发送或接收屏幕共享。",
            "3. MAC端需要为神旗视讯客户端“打开屏幕录制权限”：在“系统偏好设置>安全性与隐私>隐私>屏幕录制”中添加神旗视讯应用。",
          ],
        },
        {
          value: "会议中共享视频时听不到视频的声音",
          body: [
            "1. 确保共享屏幕或应用时，勾选”同时共享电脑声音“。",
            "2. 共享方确保本地声音设备是否工作正常，若本地能够听到视频声音，尝试提高播放的音量。",
            "3. IOS/Android端共享屏幕暂时不支持共享声音。",
          ],
        },
        {
          value: "用什么浏览器观看直播，效果更好",
          body: [
            {
              value: "为保证给您更好的直播体验，建议您使用以下浏览器观看直播：",
              imgUrl: require("@/imgs/browser_img.png"),
            },
          ],
        },
        {
          value: "微信中不能观看直播",
          body: [
            "如果您需要在微信中观看直播，您必须设置合法的域名及证书。你也可以使用浏览器方式打开链接观看直播。",
          ],
        },
        {
          value: "如何扫描二维码入会",
          body: [
            "1. 仅“预约的会议”支持二维码入会。",
            "2. 会议预约后，登录神旗视讯web管理页面，在预约会议详情中复制二维码发送给相关与会者。",
            "3. 与会者用神旗视讯客户端-移动端，直接扫描会议二维码入会；或点击“扫描”图标后，识别已存储的二维码图片入会。",
          ],
        },

        {
          value: "如何让他人控制和管理自己的会",
          body: [
            "1. 默认只有会议所有者和系统管理员能控制和管理该会议",
            "2. 设置联席会议管理员可以让更多人一起控制和管理该会议",
            "3. 如何设置联席会议管理员？",
            "（1） 只有具备会议管理员角色的用户可以成为联席会议管理员",
            "（2） 预约会议时将其他会议管理员添加为会议受邀用户，该会议管理员便可从终端或web管理页面管理控制该会议",
          ],
        },
        {
          value: "如何保障会议安全",
          body: [
            "1. 会议密码：预约会议和即时会议将默认生成会议密码。个人会议室可以登录神旗视讯web管理页面设置会议密码。",
            "2. 禁止访客入会：预约的会议或个人会议室，设置了禁止“允许访客拨入”，则所有访客/未登录用户将无法参会。",
            "3. 屏幕水印：预约的会议或个人会议室，启用了“屏幕水印”，保护您共享的内容，防止在未经允许的情况下截取您的共享内容；（注意屏幕水印功能启用后，未登录用户/访客，将无法参会）。",
            "4. 移除会议：当有陌生人进入会议时，可以从神旗视讯web管理页面，在该场会议的成员列表中，将其“移出会议”。",
            "5. 锁定会议：参会者到齐之后，在神旗视讯web管理页面->会议控制中启用“锁定会议”，避免其他人加入正在进行的会议。",
          ],
        },
        {
          value: "会议邀请信息中，点击会议链接⽆法成功⼊会",
          body: [
            {
              value:
                "1.若您的设备没有安装神旗视讯APP，请在当前网站的“下载中心”下载并安装最新版本。",
            },
            {
              value:
                "2.神旗视讯 Windows、macOS、Android、HarmonyOS 1.1.0 以下版本及 iOS 2.0.6 以下版本，不支持通过会议链接入会，请升级到最新版本。",
            },
            {
              value:
                "3. 若您使⽤的MAC电脑中，未安装神旗视讯APP，点击会议链接后⽆法打开⻚⾯，请点击浏览器返回键，按照提示下载安装神旗视讯APP后，重新“加⼊会议“， 或选择⽤其他浏览器打开会议链接。",
              imgUrl: require("@/imgs/meeting_url_hint.png"),
            },
            {
              value:
                "4. 若从其他应⽤，如微信，点击会议链接，提示“请点击右上⻆，选择以浏览器⽅式打开，重新加⼊会议”，请按照提示选择“浏览器”打开，或将链接复制⾄浏览器地址栏打开。",
              imgUrl: require("@/imgs/meeting_url_hint2.png"),
            },
          ],
        },
        {
          value: "【Windows】Windows客户端的下载和安装",
          body: [
            {
              value: "下载及安装如下：",
            },
            {
              value: "1. 打开神旗视讯下载官网 <a target='_blank' style='color:#0465e6' href='https://shenqi.internetware.cn'>https://shenqi.internetware.cn</a> ,如下图。下载后，按提示安装即可。",
              imgUrl: require("@/imgs/windows_download_fqa.png"),
            },

            {
              value: "2. 安装神旗视讯App后，为保障正常使用，需另行安装VC运行库。",
            },

            {
              value:
                "3. VC运行库下载官网 <a target='_blank' style='color:#0465e6' href='https://learn.microsoft.com/en-us/cpp/windows/latest-supported-vc-redist?view=msvc-170'>https://learn.microsoft.com/en-us/cpp/windows/latest-supported-vc-redist?view=msvc-170</a>  点击即可下载，如下图：",
              imgUrl: require("@/imgs/windows_download_link_fqa.png"),
            },
            {
              value:
                "4. 下载后双击安装包，按照提示安装后，即可正常使用神旗视讯App。",
            },
          ],
        },
        {
          value: "【Windows】Win7客户端无法登录和不能入会",
          body: [
            {
              value: "若排查网络原因后依然无法登录,可能因为旧版本Windows7默认不支持TLS1.2,请尝试以下办法启用TLS1.2支持：",
            },
            {
              value: "1. 安装微软官方补丁windows6.1-kb3140245，请到以下地址下载补丁：",
            },

            {
              value: "<a target='_blank' style='color:#0465e6' href='https://catalog.update.microsoft.com/search.aspx?q=kb3140245'>https://catalog.update.microsoft.com/search.aspx?q=kb3140245</a> 如下图：",
              imgUrl: require("@/imgs/windows_fqa_login.png"),
            },

            {
              value:
                "下载后，安装即可。",
            },
            {
              value:
                "2. 安装Enable_TLS_1.2.reg，点击以下地址下载：<a style='color:#0465e6' href='/download/win7/Enable_TLS_1.2.reg.zip'>Enable_TLS_1.2.reg.zip</a> 下载后，双击导入注册表启用支持",
            },
            {
              value:
                "3. 完成以上操作，请重启电脑后，继续尝试登录和入会。",
            },
          ],
        },
        {
          value: "【macOS】客户端首次共享屏幕需授权",
          body: [
            {
              value: "神旗视讯macOS客户首次共享屏幕，需要进行权限授予，流程如下：",
            },
            {
              value:
                "1.点击桌面左上角苹果图标→系统设置→隐私与安全性→屏幕录制，如下图：",
              imgUrl: require("@/imgs/macos_client.png"),
            },

            {
              value:
                "2.找到神旗视讯App并打开录制权限即可，如下图。（需解锁安全与隐私权限的，点按锁按钮以进行更改）",
              imgUrl: require("@/imgs/macos_client2.png"),
            },
          ],
        },
        {
          value: "【macOS】会议中，全屏模式下，无法共享App",
          body: [
            {
              value: "1.神旗视讯macOS支持在普通视窗模式下，共享桌面及App，如下图：",
              imgUrl: require("@/imgs/macos_meeting.png"),
            },
            {
              value: "2.全屏模式下，仅支持共享桌面，如下图：",
              imgUrl: require("@/imgs/macos_meeting2.png"),
            },

            {
              value:
                "3.如果需要共享App，请点击右上角“退出全屏”，再在工具条点击 “共享屏幕”即可共享。",
            },
          ],
        },
         {
          value: "【Linux】神旗视讯Linux（统信 x86）版本",
          body: [
            {
              value: "神旗视讯Linux版本支持国产统信x86系统，请在“下载中心”中下载并安装，在“用户指南”—“Linux客户端使用指南”了解详细使用流程。",
            },
            {
              value: "神旗视讯Linux版本须在“开发者模式”下安装使用，统信UOS进入开发者模式操作流程如下：",
            },

            {
              value:
                "依次点击【控制中心】—【通用】—【进入开发者模式】—选择【在线激活】—【下一步】—【重新启动】",
            },
              {
              value: "重启系统后即可成功启用开发者模式，如下图：",
               imgUrl: require("@/imgs/serve_linux.png"),
            },
          ],
        },
         {
          value: "参会者无法共享屏幕",
          body: [
            {
              value: "用户网络状况较差，速率过低时，将无法共享屏幕。",
            },
          ],
        },
        {
          value: "【Android】放大查看共享内容时不清晰",
          body: [
            {
              value: "Android端查看共享内容时，可以通过手势放大/缩小共享内容，也可以双击放大/双击还原内容，",
            },
              {
              value: "如果您放大查看共享内容时不清晰，建议您横屏观看横向共享的内容，竖屏观看竖向共享的内容。",
            },
           
          ],
        },
      ],
      breadcrumbValue: "",
      bodyList: [],
    };
  },
  methods: {
    valueClick(item, index) {
      this.breadcrumbValue = item.value;
      this.valueFlag = false;
      item.body.forEach((item) => {
        this.bodyList.push(item);
      });
    },
    backClick() {
      this.valueFlag = true;
      this.breadcrumbValue = "";
      this.bodyList.length = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.all {
  width: 100%;
  height: 100%;
  .all_ol {
    ol {
      li:hover {
        color: #026ffe;
        cursor: pointer;
      }
    }
  }
}
ol {
  height: 342px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #425473;
  line-height: 38px;
  margin: 10px 0 0 18px;
  li {
    display: list-item;
    list-style-type: decimal;
  }
}
.allValue {
  min-width: 400px;
  height: 100%;
  .breadcrump {
    .el-breadcrumb {
      height: 32px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #425473;
      line-height: 32px;
      /deep/.el-breadcrumb__inner {
        cursor: pointer;
        color: #425473;
      }
      /deep/.el-breadcrumb__inner:hover {
        color: #0465e6;
      }
    }
  }
  .body {
    min-width: 100%;
    height: 100%;
    float: left;
    margin-top: 24px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #151515;
    line-height: 28px;
    h3 {
      font-size: 24px;
    }
    ol {
      width: 95%;
      height: 100%;
      margin: 15px 0 30px 0 !important;
      li {
        color: #666666;
        list-style: none;
        span {
          display: block;
          width: 95%;
        }
      }
    }
    .fqa_img {
      width: auto;
      height: 350px;
    }
  }
}
</style>